import React, { FC } from 'react';
import styles from './TextDivider.scss';
import { Text } from '@wix/design-system';

type Props = {
  text: string;
};

export const TextDivider: FC<Props> = ({ text }) => {
  return (
    <div className={styles.textDivider}>
      <div className={styles.textDividerLine} />
      <Text secondary light size="tiny">
        {text}
      </Text>
      <div className={styles.textDividerLine} />
    </div>
  );
};
